import React from "react";
import { FaFilter } from "react-icons/fa";
import { ReportActionButton } from "./ReportActionButton";

export function ReportFilterButton({ children, ...props }) {
  return (
    <ReportActionButton leftIcon={<FaFilter />} variant="secondary" {...props}>
      {children}
    </ReportActionButton>
  );
}
